module.exports = __webpack_public_path__ + "img/service-1-INTshouhou.86f7f1f8.png";